import { Route } from '@/app/router'
import DepartmentSelected from '@/middleware/DepartmentSelected'

const Integrations = () => import('./index.vue')

const integrationsMeta = {
	sort: 13,
	displayInSidebar: true,
	displayName: 'ad',
	icon: 'fal window',
	activeIcon: 'far window'
}

const integrationsProps = ['page', 'perPage']

export default new Route('/integrations', Integrations)
	.as('Dashboard:Integrations')
	.meta(integrationsMeta)
	.props(integrationsProps)
	.permissions(['HAS_SELECTED_DEPARTMENT', 'VIEW_EXTERNAL_INTEGRATION_SETTINGS', 'VIEW_EXTERNAL_INTEGRATION'])
	.middlewares([DepartmentSelected])
